import $ from 'jquery';

const BANNER_TARGET_CLASS = '.js-cpl-banner';
const ITEM_SELECTOR = 'a.pill-button';
const ACTIVE_CLASS = 'active';
const CPL_ID_PARAM = 'cplid';

export default function() {
  const urlParams = new URLSearchParams(window.location.search);
  const cplId = urlParams.get(CPL_ID_PARAM);

  $(ITEM_SELECTOR, $(BANNER_TARGET_CLASS)).each((i, el) => {
    const $anchor = $(el);

    if ($anchor.length) {
      const href = $anchor.attr('href');
      const hrefParts = href ? href.split('?') : [];
      const anchorUrlParams = new URLSearchParams(hrefParts.length === 2 ? '?' + hrefParts[1] : '');
      const anchorCplId = anchorUrlParams.get(CPL_ID_PARAM);

      if (anchorCplId === cplId) {
        $anchor.addClass(ACTIVE_CLASS);
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/scripts/entry-points/plp/cpl-banner.js